import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Select, DatePicker } from 'antd';
import queryString from "query-string";

const mySwal = withReactContent(Swal);

const RequestInvoice = ({ token }) => {

    const history = useHistory();
    const location = useLocation();

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [idType, setIdType] = useState("NRIC");
    const [idValue, setIdValue] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState(null);
    const [postcode, setPostcode] = useState("");
    const [type, setType] = useState("Manual");
    const [transactionId, setTransactionId] = useState("");
    const [amount, setAmount] = useState(0);
    const [transactionDate, setTransactionDate] = useState("");
    const [transactionTime, setTransactionTime] = useState(null);
    const [machineId, setMachineId] = useState(null);
    const [machineList, setMachineList] = useState([]);
    const [outletName, setOutletName] = useState("");
    const [method, setMethod] = useState(null);
    const [outletID, setOutletID] = useState("");
    const [country, setCountry] = useState("");
    const [machineData, setMachineData] = useState([]);
    const [userType, setUserType] = useState("Individual");
    const [machineType, setMachineType] = useState(null);
    const [machineTypeList, setMachineTypeList] = useState([]);

    useEffect(() => {
        const { outletId } = queryString.parse(location.search);

        if (outletId) {
            setOutletID(outletId)
            setLoading(true)
            axios
                .post("/api/nonuser/getMachineList", { outletId })
                .then(res => {
                    setMachineData(res.data.data.machineData)
                    let machineOptions = []
                    let machineTypeOptions = []
                    for (let i = 0; i < res.data.data.machineData.length; i++) {
                        let machineObject = {
                            value: res.data.data.machineData[i].machineNo,
                            label: `${res.data.data.machineData[i].name} (${res.data.data.machineData[i].type}${res.data.data.machineData[i].capacity ? ` ${res.data.data.machineData[i].capacity}` : ""})`
                        }
                        machineOptions.push(machineObject)

                        let foundMachineType = machineTypeOptions.filter(data => data.value === res.data.data.machineData[i].type)[0]
                        if (!foundMachineType) {
                            let machineTypeObject = {
                                value: res.data.data.machineData[i].type,
                                label: res.data.data.machineData[i].type
                            }
                            machineTypeOptions.push(machineTypeObject)
                        }
                    }

                    setMachineList(machineOptions)
                    setMachineTypeList(machineTypeOptions)
                    setOutletName(res.data.data.outlet.outlet_fullname)
                    setCountry(res.data.data.country)
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                });
        } else if (location.state) {
            if (location.state.transaction) {
                setType("Transaction");
                setTransactionId(location.state.transaction.id);
            } else if (location.state.subscription) {
                setType("Subscription");
                setTransactionId(location.state.subscription.id);
            }

            if (location.state.user) {
                if (location.state.user.einvoice_id_type) {
                    setIdType(location.state.user.einvoice_id_type);
                }
                if (location.state.user.einvoice_id_value) {
                    setIdValue(location.state.user.einvoice_id_value);
                }
                if (location.state.user.name) {
                    setName(location.state.user.name);
                }
                if (location.state.user.email) {
                    setEmail(location.state.user.email);
                }
                if (location.state.user.number) {
                    setPhone(location.state.user.number);
                }
                if (location.state.user.address) {
                    setAddress(location.state.user.address);
                }
                if (location.state.user.city) {
                    setCity(location.state.user.city);
                }
                if (location.state.user.postcode) {
                    setPostcode(location.state.user.postcode);
                }
                if (location.state.user.state) {
                    setState(location.state.user.state);
                }
                if (location.state.user.country) {
                    setCountry(location.state.user.country);
                }
            }
        } else {
            history.push("/")
        }
    }, [])

    const dateOnChange = (date, dateString) => {
        if (date) {
            setTransactionDate(dateString)
            if (new Date() > new Date(new Date(dateString).setDate(new Date(dateString).getDate() + 3))) {
                mySwal.fire(t("Warning"), t("Transaction date is more than 3 days"), "warning");
            }
        } else {
            setTransactionDate("")
        }
    }

    const handleRequestAs = (value) => {
        setUserType(value)
        if (value === "Company") {
            setIdType("BRN")
        } else {
            setIdType("NRIC")
        }
    }

    const handleMachineType = (value) => {
        setMachineType(value)

        let filterMachineOptions = machineData.filter(machine => machine.type === value)
        let machineOptions = []
        for (let i = 0; i < filterMachineOptions.length; i++) {
            let machineObject = {
                value: filterMachineOptions[i].machineNo,
                label: `${filterMachineOptions[i].name} (${filterMachineOptions[i].type}${filterMachineOptions[i].capacity ? ` ${filterMachineOptions[i].capacity}` : ""})`
            }
            machineOptions.push(machineObject)
        }
        setMachineList(machineOptions)
        setMachineId(null)
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const emailRegex = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
        const numberRegex = /^\d+$/;

        if (!idType || !idValue || !name || !email || !phone || !address || !city || !state || !postcode) {
            mySwal.fire(t("Error"), t("Please fill in all the required fields before submit."), "error");
        } else if (!emailRegex.test(email)) {
            mySwal.fire(t("Error"), t("Invalid Email Address"), "error");
        } else if (country && country !== "Malaysia") {
            mySwal.fire(t("Error"), t("Only can request einvoice for Malaysia Outlet"), "error");
        } else if (!numberRegex.test(phone) || phone.length <= 9 || phone.length >= 12 || phone.substring(0, 2) !== "01") {
            mySwal.fire(t("Error"), t("Invalid Phone Number"), "error");
        } else {
            setLoading(true);
            let param = {
                idType,
                idValue,
                name,
                email,
                phone,
                address,
                city,
                state,
                postcode,
                type,
                transactionId,
            }

            axios
                .post("/api/user/requestInvoice", param, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    mySwal.fire(t("Success"), t("E-Invoice requested successfully"), "success");
                    history.push('/');
                    setLoading(false);
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        }
    }

    const handleManualSubmit = (e) => {
        e.preventDefault();

        const emailRegex = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
        const numberRegex = /^\d+$/;

        if (!machineId || !transactionDate || !transactionTime || !amount || !method || !idType || !idValue || !name || !phone || !email || !address || !city || !postcode || !state) {
            mySwal.fire(t("Error"), t("Please fill in all the required fields before submit."), "error");
        } else if (!emailRegex.test(email)) {
            mySwal.fire(t("Error"), t("Invalid Email Address"), "error");
        } else if (country && country !== "Malaysia") {
            mySwal.fire(t("Error"), t("Only can request einvoice for Malaysia Outlet"), "error");
        } else if (!numberRegex.test(phone) || phone.length <= 9 || phone.length >= 12 || phone.substring(0, 2) !== "01") {
            mySwal.fire(t("Error"), t("Invalid Phone Number"), "error");
        } else {
            setLoading(true);
            let param = {
                idType,
                idValue,
                name,
                email,
                phone,
                address,
                city,
                state,
                postcode,
                method,
                amount,
                transactionDate,
                transactionTime,
                outletId: outletID,
                machineId,
                machineName: machineData.filter(data => data.machineNo === machineId)[0].name,
                machineType: machineData.filter(data => data.machineNo === machineId)[0].type,
                machineCapacity: machineData.filter(data => data.machineNo === machineId)[0].capacity,
            }

            axios
                .post("/api/nonuser/requestInvoice", param)
                .then(res => {
                    mySwal.fire(t("Success"), t("E-Invoice requested successfully"), "success");
                    history.push('/');
                    setLoading(false);
                })
                .catch(err => {
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    setLoading(false);
                });
        }
    }

    return (
        <div id="setting-page">
            <div className="feedback">
                <div id="user-header">
                    <h5><i onClick={e => history.goBack()} className="bi bi-chevron-left me-3"></i> <strong>{t("Request E-Invoice")}</strong></h5>
                </div>

                <div id="user-body">
                    <form onSubmit={type === "Manual" ? handleManualSubmit : handleSubmit}>
                        <div className="form-group px-5">
                            {
                                type === "Manual" ? (
                                    <div>
                                        <h5 className="pt-3 text-center">{t("Outlet")}: {outletName}</h5>

                                        <p className="pt-3">{t("Machine Type")}</p>
                                        <Select
                                            id="machineType"
                                            name="machineType"
                                            style={{ width: "100%" }}
                                            placeholder={t("Select machine type")}
                                            options={machineTypeList}
                                            showSearch
                                            optionFilterProp="label"
                                            onChange={(value) => handleMachineType(value)}
                                            value={machineType}
                                            className="select-input"
                                        />

                                        <p className="pt-3">{t("Machine")}</p>
                                        <Select
                                            id="machine"
                                            name="machine"
                                            style={{ width: "100%" }}
                                            placeholder={t("Select machine")}
                                            options={machineList}
                                            showSearch
                                            optionFilterProp="label"
                                            onChange={(value) => setMachineId(value)}
                                            value={machineId}
                                            className="select-input"
                                        />

                                        <p className="pt-3">{t("Transaction Date")}</p>
                                        <DatePicker
                                            id="transactionDate"
                                            name="transactionDate"
                                            onChange={dateOnChange}
                                            style={{ width: "100%" }}
                                            placeholder={t("Select transaction date")}
                                            required
                                            className="select-input"
                                        />

                                        <p className="pt-3">{t("Transaction Time")}</p>
                                        <Select
                                            id="transactionTime"
                                            name="transactionTime"
                                            style={{ width: "100%" }}
                                            placeholder={t("Select transaction time")}
                                            options={[
                                                { value: "00:00:00", label: "00:00 - 00:30" },
                                                { value: "00:30:00", label: "00:30 - 01:00" },
                                                { value: "01:00:00", label: "01:00 - 01:30" },
                                                { value: "01:30:00", label: "01:30 - 02:00" },
                                                { value: "02:00:00", label: "02:00 - 02:30" },
                                                { value: "02:30:00", label: "02:30 - 03:00" },
                                                { value: "03:00:00", label: "03:00 - 03:30" },
                                                { value: "03:30:00", label: "03:30 - 04:00" },
                                                { value: "04:00:00", label: "04:00 - 04:30" },
                                                { value: "04:30:00", label: "04:30 - 05:00" },
                                                { value: "05:00:00", label: "05:00 - 05:30" },
                                                { value: "05:30:00", label: "05:30 - 06:00" },
                                                { value: "06:00:00", label: "06:00 - 06:30" },
                                                { value: "06:30:00", label: "06:30 - 07:00" },
                                                { value: "07:00:00", label: "07:00 - 07:30" },
                                                { value: "07:30:00", label: "07:30 - 08:00" },
                                                { value: "08:00:00", label: "08:00 - 08:30" },
                                                { value: "08:30:00", label: "08:30 - 09:00" },
                                                { value: "09:00:00", label: "09:00 - 09:30" },
                                                { value: "09:30:00", label: "09:30 - 10:00" },
                                                { value: "10:00:00", label: "10:00 - 10:30" },
                                                { value: "10:30:00", label: "10:30 - 11:00" },
                                                { value: "11:00:00", label: "11:00 - 11:30" },
                                                { value: "11:30:00", label: "11:30 - 12:00" },
                                                { value: "12:00:00", label: "12:00 - 12:30" },
                                                { value: "12:30:00", label: "12:30 - 13:00" },
                                                { value: "13:00:00", label: "13:00 - 13:30" },
                                                { value: "13:30:00", label: "13:30 - 14:00" },
                                                { value: "14:00:00", label: "14:00 - 14:30" },
                                                { value: "14:30:00", label: "14:30 - 15:00" },
                                                { value: "15:00:00", label: "15:00 - 15:30" },
                                                { value: "15:30:00", label: "15:30 - 16:00" },
                                                { value: "16:00:00", label: "16:00 - 16:30" },
                                                { value: "16:30:00", label: "16:30 - 17:00" },
                                                { value: "17:00:00", label: "17:00 - 17:30" },
                                                { value: "17:30:00", label: "17:30 - 18:00" },
                                                { value: "18:00:00", label: "18:00 - 18:30" },
                                                { value: "18:30:00", label: "18:30 - 19:00" },
                                                { value: "19:00:00", label: "19:00 - 19:30" },
                                                { value: "19:30:00", label: "19:30 - 20:00" },
                                                { value: "20:00:00", label: "20:00 - 20:30" },
                                                { value: "20:30:00", label: "20:30 - 21:00" },
                                                { value: "21:00:00", label: "21:00 - 21:30" },
                                                { value: "21:30:00", label: "21:30 - 22:00" },
                                                { value: "22:00:00", label: "22:00 - 22:30" },
                                                { value: "22:30:00", label: "22:30 - 23:00" },
                                                { value: "23:00:00", label: "23:00 - 23:30" },
                                                { value: "23:30:00", label: "23:30 - 00:00" },
                                            ]}
                                            showSearch
                                            optionFilterProp="label"
                                            onChange={(value) => setTransactionTime(value)}
                                            value={transactionTime}
                                            className="select-input"
                                        />

                                        <p className="pt-3">{t("Transaction Amount")}</p>
                                        <input
                                            type="number"
                                            step="0.01"
                                            min={0}
                                            className="form-control"
                                            id="amount"
                                            name="amount"
                                            placeholder={t("Enter Transaction Amount, Example: 1.50")}
                                            value={amount}
                                            onChange={e => setAmount(e.target.value)}
                                            required
                                        />

                                        <p className="pt-3">{t("Payment Method")}</p>
                                        <Select
                                            id="method"
                                            name="method"
                                            style={{ width: "100%" }}
                                            placeholder={t("Select payment method")}
                                            options={[
                                                { value: "Cash", label: t("Cash") },
                                                { value: "Cashless", label: t("Cashless (e-Wallet / DuitNow QR)") }, // non user or static duitnow transaction
                                                { value: "Terminal", label: t("Paywave (Tap with Debit/Credit Card)") },
                                            ]}
                                            showSearch
                                            optionFilterProp="label"
                                            onChange={(value) => setMethod(value)}
                                            value={method}
                                            className="select-input"
                                        />
                                    </div>
                                ) : null
                            }

                            <p className="pt-3">{t("Request as")}</p>
                            <Select
                                placeholder={t("Select Request as")}
                                style={{ width: "100%" }}
                                value={userType}
                                onChange={value => handleRequestAs(value)}
                                options={[
                                    { value: "Individual", label: t("Individual") },
                                    { value: "Company", label: t("Company") },
                                ]}
                                className="select-input"
                            />

                            {
                                userType === "Individual" ? (
                                    <div>
                                        <p className="pt-3">{t("ID Type")}</p>
                                        <Select
                                            placeholder={t("Select ID Type")}
                                            style={{ width: "100%" }}
                                            value={idType}
                                            onChange={value => setIdType(value)}
                                            options={[
                                                { value: "NRIC", label: "NRIC" },
                                                { value: "PASSPORT", label: "PASSPORT" },
                                                { value: "ARMY", label: "ARMY" },
                                                // { value: "BRN", label: "BRN" },
                                            ]}
                                            className="select-input"
                                        />
                                    </div>
                                ) : null
                            }

                            <p className="pt-3">{userType === "Company" ? t("Business Registration Number (BRN)") : t(idType)}</p>
                            <input
                                type="text"
                                className="form-control"
                                id="idValue"
                                name="idValue"
                                placeholder={userType === "Company" ? t("Business Registration Number (BRN)") : t(idType)}
                                value={idValue}
                                onChange={e => setIdValue(e.target.value)}
                                required
                            />

                            <p className="pt-3">{userType === "Company" ? t("Company Name") : t("Name")}</p>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                name="name"
                                placeholder={userType === "Company" ? t("Company Name") : t("Name")}
                                value={name}
                                onChange={e => setName(e.target.value)}
                                required
                            />

                            <p className="pt-3">{t("Phone")}</p>
                            <input
                                type="text"
                                className="form-control"
                                id="phone"
                                name="phone"
                                placeholder={t("Phone")}
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                                required
                            />

                            <p className="pt-3">{t("Email")}</p>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                name="email"
                                placeholder={t("Email")}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />

                            <p className="pt-3">{t("Address")}</p>
                            <input
                                type="text"
                                className="form-control"
                                id="address"
                                name="address"
                                placeholder={t("Address")}
                                value={address}
                                onChange={e => setAddress(e.target.value)}
                                required
                            />

                            <p className="pt-3">{t("City")}</p>
                            <input
                                type="text"
                                className="form-control"
                                id="city"
                                name="city"
                                placeholder={t("City")}
                                value={city}
                                onChange={e => setCity(e.target.value)}
                                required
                            />

                            <p className="pt-3">{t("Postcode")}</p>
                            <input
                                type="text"
                                className="form-control"
                                id="postcode"
                                name="postcode"
                                placeholder={t("Postcode")}
                                value={postcode}
                                onChange={e => setPostcode(e.target.value)}
                                required
                            />

                            <p className="pt-3">{t("State")}</p>
                            <Select
                                placeholder={t("Select State")}
                                style={{ width: "100%" }}
                                value={state}
                                onChange={value => setState(value)}
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    { value: "JOHOR", label: "Johor" },
                                    { value: "KEDAH", label: "Kedah" },
                                    { value: "KELANTAN", label: "Kelantan" },
                                    { value: "MELAKA", label: "Melaka" },
                                    { value: "NEGERI SEMBILAN", label: "Negeri Sembilan" },
                                    { value: "PAHANG", label: "Pahang" },
                                    { value: "PULAU PINANG", label: "Pulau Pinang" },
                                    { value: "PERAK", label: "Perak" },
                                    { value: "PERLIS", label: "Perlis" },
                                    { value: "SELANGOR", label: "Selangor" },
                                    { value: "TERENGGANU", label: "Terengganu" },
                                    { value: "SABAH", label: "Sabah" },
                                    { value: "SARAWAK", label: "Sarawak" },
                                    { value: "WILAYAH PERSEKUTUAN KUALA LUMPUR", label: "Wilayah Persekutuan Kuala Lumpur" },
                                    { value: "WILAYAH PERSEKUTUAN LABUAN", label: "Wilayah Persekutuan Labuan" },
                                    { value: "WILAYAH PERSEKUTUAN PUTRAJAYA", label: "Wilayah Persekutuan Putrajaya" }
                                ]}
                                className="select-input"
                            />

                            <div>
                                {
                                    loading ? (
                                        <div className="text-center">
                                            <div
                                                className="spinner-border"
                                                style={{ color: "#ffd109" }}
                                                role="status"
                                            >
                                                <span className="sr-only">Loading ...</span>
                                            </div>
                                        </div>
                                    ) : <input id="request-einvoice" type="submit" className="btn big-button form-control mt-3" value={t("Request E-Invoice")} />
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.user.token,
    };
};

export default connect(mapStateToProps, null)(RequestInvoice);